import React from "react";

const MyInterestCard = ({
  width = 132,
  height = 132,
  marginLeft = 0,
  marginBottom = 20,
  data,
  handleViewDetail,
  isEditMode = false,
  isSelected = false,
  onSelect,
}) => {
  const handleCheckboxClick = (e) => {
    e.stopPropagation();
    onSelect && onSelect(data.id);
  };

  return (
    <div
      className="nib-box interest-box"
      style={{
        // width,
        minWidth: `${width}px`,
        marginLeft,
        marginBottom,
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        boxSizing: "border-box",
        padding: "0",
        borderRadius: "8px",
        cursor: "pointer",
        transition: "transform 0.3s ease-in-out",
        backgroundColor: "#1a1a1a",
        border: "none",
      }}
      onClick={() => handleViewDetail && handleViewDetail(data?.id, data.title)}
    >
      {/* Only show checkbox if in edit mode */}
      {isEditMode && (
        <div
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            zIndex: 2,
          }}
        >
          <input
            type="checkbox"
            checked={isSelected}
            onChange={handleCheckboxClick}
            style={{
              width: "20px",
              height: "20px",
              cursor: "pointer",
              accentColor: "#28a745",
              border: "2px solid #ffffff",
              borderRadius: "3px",
            }}
          />
        </div>
      )}

      <div style={{ position: "relative", width: "100%" }}>
        <img
        className="myinterestcardimage"
          src={data?.image || "https://via.placeholder.com/300x200"}
          // style={{
          //   width: "132px",
          //   objectFit: "cover",
          //   height: "132px",
          //   borderRadius: "12px",
          //   display: "block",
          // }}
          alt={data?.title}
        />

        <div
          className="text-center mt-1 interest_text_container"
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "8px",
          }}
        >
          <h6
            className="text-white interest_category_name"
            style={{
              margin: "0",
              fontSize: "0.85rem",
              lineHeight: "1.3",
              wordWrap: "break-word",
              overflowWrap: "break-word",
              whiteSpace: "normal",
              textAlign: "center",
              width: "100%",
              color: "#ffffff",
            }}
          >
            {data?.title || ""}
          </h6>
        </div>
      </div>
    </div>
  );
};

export default MyInterestCard;

// import React from "react";

// const MyInterestCard = ({
//   width,
//   height,
//   marginLeft,
//   marginBottom = 40,
//   data,
//   borderRadius,
//   padding = 0,
//     handleViewDetail,
//   isEditMode = false,
//   isSelected = false,
//   onSelect,
// }) => {

//   const handleCheckboxClick = (e) => {
//     e.stopPropagation();
//     onSelect && onSelect(data.id);
//   };
//   //   var result = text.slice(0, count) + (text.length > count ? "..." : "");
//   return (
//     <div
//       className="nib-box interest-box card-interest2"
//       style={{
//         width,
//         // height, // Let height be determined by content
//         marginLeft,
//         marginBottom,
//         borderRadius:  "12px",
//         padding: "8px",
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         backgroundColor: "#333",
//         boxSizing: "border-box",
//       }}
//     >
//             {isEditMode && (
//         <div
//           style={{
//             position: "absolute",
//             top: "20px",
//             right: "20px",
//             zIndex: 2,
//           }}
//         >
//           <input
//             type="checkbox"
//             checked={isSelected}
//             onChange={handleCheckboxClick}
//             style={{
//               width: "20px",
//               height: "20px",
//               cursor: "pointer",
//               accentColor: "#28a745",
//               border: "2px solid #ffffff",
//               borderRadius: "3px",
//             }}
//           />
//         </div>
//       )}
//       {/* Image container */}
//       <div
//         style={{
//           width: "100%",
//           height: 132,
//           marginBottom: "8px",
//         }}
//       >
//               <img
//           src={data?.image || "https://via.placeholder.com/300x200"}
//           style={{
//             width: "132px",
//             objectFit: "cover",
//             height: "132px",
//             borderRadius: "12px",
//             display: "block",
//           }}
//           alt={data?.title}
//         />
//       </div>

//       {/* Text container - below image */}
//       <div
//         className="text-center mt-1 interest_text_container"
//         style={{
//           width: "100%", // Full width
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "center",
//           flexGrow: 1,
//         }}
//       >
//         {/* Category Name */}
//         <h6
//           className="text-white interest_category_name"
//           style={{
//             margin: "0 0 4px 0",
//             fontSize: "0.85rem",
//             lineHeight: "1.3",
//             wordWrap: "break-word",
//             overflowWrap: "break-word",
//             whiteSpace: "normal",
//             textAlign: "center",
//             width: "100%",
//           }}
         
//         >
//           {data?.title || ""}
//         </h6>

      
//       </div>
//     </div>
//   );
// };

// export default MyInterestCard;
